import { IItemCommercialTranslationData } from '@/models';
import {
  IItemCommercialTranslationService,
  IItemCommercialTranslationPaginatedListData,
  IItemCommercialTranslationUploadResponseData
} from './itemcommercialtranslation.types';
import { AxiosInstance } from 'axios';

export class ItemCommercialTranslationService
  implements IItemCommercialTranslationService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/csi/item-commercial-translations/';
  }

  fetchItemCommercialTranslations(
    page: number,
    search?: string
  ): Promise<IItemCommercialTranslationPaginatedListData> {
    const params = new URLSearchParams();

    params.append('page', page.toString());
    if (search) {
      params.append('search', search);
    }

    return this.axios
      .get<IItemCommercialTranslationPaginatedListData>(`${this.endpoint}`, {
        params: params
      })
      .then(({ data }) => data);
  }

  fetchItemCommercialTranslation(
    id: number
  ): Promise<IItemCommercialTranslationData> {
    return this.axios
      .get<IItemCommercialTranslationData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createItemCommercialTranslation(
    data: IItemCommercialTranslationData
  ): Promise<IItemCommercialTranslationData> {
    return this.axios
      .post<IItemCommercialTranslationData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateItemCommercialTranslation(
    data: IItemCommercialTranslationData
  ): Promise<IItemCommercialTranslationData> {
    return this.axios
      .patch<IItemCommercialTranslationData>(
        `${this.endpoint}${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteItemCommercialTranslation(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }

  uploadItemCommercialTranslationFile(
    file: File
  ): Promise<IItemCommercialTranslationUploadResponseData> {
    const formData = new FormData();
    formData.append('file_upload', file);

    return this.axios
      .post<IItemCommercialTranslationUploadResponseData>(
        `${this.endpoint}upload_file/`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 1000 * 60 * 5 //5mins
        }
      )
      .then(({ data }) => data);
  }

  exportItemCommercialTranslations(): Promise<Blob> {
    return this.axios
      .get<Blob>(`${this.endpoint}export/`, {
        responseType: 'blob'
      })
      .then(({ data }) => data);
  }
}
